module.exports = __webpack_public_path__ + "static/img/zhufu5.b9f44172.jpg";